export default __webpack_public_path__ + "static/media/icon-linkedin.bdb88edd.svg";